<template>
  <section
    class="column removeTopPadding"
    :style="{ backgroundColor: box.boxColor, color: box.boxTextColor }"
    @click="routerPush()"
  >
    <!-- BOX BODY -->
    <div class="box-body">
      <svg
        width="89"
        height="96"
        viewBox="0 0 89 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M56.6012 65.0752L56.033 70.4675C55.9975 70.8022 55.8856 71.1217 55.7062 71.401C55.5267 71.6802 55.2847 71.9115 54.9991 72.0764C54.7135 72.2414 54.3923 72.3355 54.0609 72.3513C53.7294 72.3672 53.3968 72.3043 53.0894 72.1677L48.1374 69.9638C47.3868 69.6312 46.7642 63.79 46.7642 63.79C46.7642 63.79 45.571 64.3592 45.1382 64.3729C44.2144 64.4017 43.5946 63.3187 43.5302 62.3803L43.6598 58.4407C43.6598 58.4407 42.3081 58.7112 41.8516 58.6778C41.2704 58.6358 40.8211 58.1398 40.538 57.6464C40.3675 57.3519 40.2666 57.0226 40.2435 56.6851L40.5606 53.0704C40.5606 53.0704 39.0607 53.0631 38.567 52.9832C38.0051 52.8906 37.5442 52.4587 37.2534 51.9518L35.4895 48.8982C33.3252 48.9827 31.164 48.4579 29.244 47.3816C27.3239 46.3053 25.7194 44.7193 24.6072 42.7982C23.013 40.0278 22.5489 36.7572 23.3166 33.7037C24.0843 30.6501 26.0212 28.0629 28.7024 26.5095C31.3879 24.9631 34.5959 24.5786 37.623 25.4402C40.6501 26.3019 43.2493 28.3393 44.8504 31.1057C45.9577 33.0297 46.5287 35.2129 46.5003 37.4147C46.472 39.6165 45.8454 41.7514 44.6897 43.5841L56.3137 63.7232C56.551 64.134 56.652 64.6087 56.6012 65.0752ZM31.5351 31.4179C30.1144 32.2414 29.0881 33.6125 28.6813 35.2306C28.2745 36.8488 28.5203 38.5819 29.3648 40.0502L40.0928 33.8537C39.2441 32.3878 37.8666 31.3083 36.2625 30.8517C34.6583 30.3951 32.9583 30.5987 31.5351 31.4179Z"
          :fill="box.graphicColor"
        />
        <path
          d="M71.2662 11.8402C77.8575 13.5179 82.7663 17.152 85.9925 22.7424C89.2187 28.3328 89.8493 34.2973 87.8842 40.636L82.5543 39.0735C83.7857 34.143 83.184 29.5682 80.7491 25.3491C78.3142 21.1299 74.7158 18.4266 69.9538 17.2393L71.2662 11.8402ZM68.2583 23.0707C71.6453 24.0677 74.1301 25.9375 75.7128 28.68C77.2955 31.4224 77.6107 34.4047 76.6586 37.6268L71.3287 36.0643C71.7656 32.4366 70.2742 29.8524 66.8546 28.3115L68.2583 23.0707ZM37.6497 1.09009C39.5475 -0.00608172 41.5358 -0.275538 43.6146 0.281721C45.6935 0.83898 47.2807 2.06692 48.3764 3.96555L83.4386 64.7215C84.5343 66.6201 84.8036 68.6093 84.2466 70.689C83.6896 72.7688 82.4622 74.3567 80.5644 75.4529L46.8785 94.9099C44.9807 96.0061 42.9924 96.2755 40.9136 95.7183C38.8348 95.161 37.2475 93.9331 36.1518 92.0345L1.08961 31.2785C-0.00607907 29.3799 -0.275418 27.3907 0.281599 25.311C0.838615 23.2312 2.06602 21.6433 3.96382 20.5471L37.6497 1.09009ZM74.7207 65.3269L43.4934 11.2161L9.80752 30.6731L41.0348 84.7839L74.7207 65.3269Z"
          :fill="box.graphicColor"
        />
      </svg>
    </div>
    <!-- <link v-if="customFonts.customFonts" :href="customFonts.customFontUrl" rel="stylesheet" /> -->

    <!-- BUTTON -->
    <div>
      <div class="box-content">
        {{ isSecLangActive ? box.boxTexts[1] : box.boxTexts[0] }}
      </div>
      <button
        class="box-button"
        v-bind:style="{
          backgroundColor: box.buttonColor,
          color: box.buttonTextColor,
        }"
      >
        {{ isSecLangActive ? box.buttonTexts[1] : box.buttonTexts[0] }}
      </button>
    </div>
  </section>
</template>

<script>
import { trackBehavior } from "../../callables";

export default {
  props: {
    box: Object,
    cookieExists: [String],
    secondLang: Boolean,
    activeLanguage: String,
    customFonts: Object,
  },
  computed: {
    isSecLangActive() {
      return this.secondLang && this.cookieExists;
    },
  },
  data() {
    return {
      activeGuestTemp: "",
    };
  },
  mounted() {
    this.activeGuestTemp = sessionStorage.getItem("activeGuestTemp");
  },
  methods: {
    routerPush: function () {
      if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
        window.open(this.box.linkiOS, "_blank");
      } else {
        window.open(this.box.linkAndroid, "_blank");
      }

      trackBehavior({
        action: "click",
        clickedInfo: this.box.boxTexts[0],
        guestID: this.activeGuestTemp,
        eventID: this.$hotelId,
        customerID: this.$customerId,
      });
    },
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

h4 {
  margin: 0px;
}

button {
  cursor: pointer;
}

/* Create three equal columns that floats next to each other */
.column {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  padding-top: 12px;
  padding-bottom: 0px;
  padding-left: 16px;
  padding-right: 16px;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}

.removeTopPadding {
  padding-top: 0px;
}
.iconBox {
  height: 70px;
  overflow: hidden;
  margin-top: 8px;
}

.iconImageBox {
  height: 70px;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 5px;
}

.iconImageBox > img {
  max-height: 100%;
  max-width: 100%;
}

.box-content {
  margin: 0 auto;
  line-height: 20px;
  margin-bottom: 10px;
}

.box-button {
  height: 40px;
  width: 190px;
  padding: 0px 9px;
  border: 2px solid transparent;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  overflow-x: hidden;
}
</style>
